const zones = [
  { name: "娱乐星闻", href: "#topics" },
  { name: "商业财经", href: "#topics" },
  { name: "主播网红", href: "#topics" },
  { name: "饭圈文化", href: "#topics" },
  { name: "品牌消费", href: "#topics" },
  { name: "平台规则", href: "#topics" },
];

const ways = [
  { name: "关键词查找", href: "#query" },
  { name: "检索热词", href: "#hot" },
  { name: "专题精选", href: "#topics" },
  { name: "内容查询", href: "#query" },
  { name: "更新动态", href: "#feed" },
  { name: "使用指引", href: "#guide" },
];

const helps = [
  { name: "怎么搜索专题", href: "#guide" },
  { name: "怎么按领域查询", href: "#guide" },
  { name: "归档内容说明", href: "#feed" },
  { name: "检索热榜更新", href: "#hot" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-archive-drawer-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">网黑料</span>
            </a>
            <p className="mt-4 max-w-xs text-[13px] leading-6 text-background-300/90">
              一个以关键词为导向的聚合检索门户，助你在各领域快速定位专题并完成内容查询。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-youtube-line", "ri-instagram-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  aria-label="社交入口"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/10 text-background-200 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">领域分区索引</h4>
            <ul className="mt-4 space-y-2.5">
              {zones.map((z) => (
                <li key={z.name}>
                  <a href={z.href} className="text-[13px] text-background-300/90 transition-colors hover:text-accent-300 whitespace-nowrap">
                    {z.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">检索方式</h4>
            <ul className="mt-4 space-y-2.5">
              {ways.map((w) => (
                <li key={w.name}>
                  <a href={w.href} className="text-[13px] text-background-300/90 transition-colors hover:text-accent-300 whitespace-nowrap">
                    {w.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50">帮助直达</h4>
            <ul className="mt-4 space-y-2.5">
              {helps.map((h) => (
                <li key={h.name}>
                  <a href={h.href} className="text-[13px] text-background-300/90 transition-colors hover:text-accent-300 whitespace-nowrap">
                    {h.name}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5 rounded-lg bg-background-200/10 p-3">
              <p className="flex items-center gap-2 text-xs text-background-300">
                <i className="ri-archive-line text-accent-300"></i>
                档案库持续归档中
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300/70">
            © 2026 网黑料 · 聚合检索门户。本页仅作索引展示，不代表站方观点。
          </p>
          <p className="flex flex-wrap items-center gap-4 text-xs text-background-300/70">
            <a href="#guide" className="hover:text-accent-300 whitespace-nowrap">检索说明</a>
            <a href="#guide" className="hover:text-accent-300 whitespace-nowrap">内容归档规则</a>
            <a href="#" className="hover:text-accent-300 whitespace-nowrap">返回顶部</a>
          </p>
        </div>
      </div>
    </footer>
  );
}